<template>
  <div class="bg" style="padding-top: 60px;">
    <v-row class="justify-center">
      <v-card class="mt-10 ml-5 mr-5" 
         max-width="300"
         min-height="360"
         @click="createNew" link   style="padding-bottom: 35px;">
        <v-img class="white--text align-end" height="100px" src="/images/new-loan.png">
          <v-card-title></v-card-title>
        </v-img>

        <v-card-title> </v-card-title>

        <v-card-subtitle class="pb-0"> </v-card-subtitle>

        <v-card-text class="text-center"> </v-card-text>

        <v-card-actions class="dashActions"  >
          <v-container>
            <v-row>
              <v-btn color="primary" text @click="createNew">{{ $t("labels.StartNewApplication") }}</v-btn>
            </v-row>
          </v-container>          
        </v-card-actions>
      </v-card>
      <v-card
        class="mt-10 ml-5 mr-5"
        max-width="300"
        min-height="360"
        v-for="(d, index) in pd.Deals"
        v-bind:key="index"
        link 
        @click="navToApplication(d)"
        style="padding-bottom: 35px;"
      >
        <v-img class="white--text align-end" height="100px" src="/images/current-loan.png">
          <v-card-title></v-card-title>
        </v-img>

        <v-card-title v-if="d.PropertyAddress">
          <span>{{ d.PropertyAddress }}</span>
        </v-card-title>
        <v-card-subtitle class="pb-0">
          {{ d.Purpose }}
          <div class="float-right">{{ d.ApplicationDate }}</div>
        </v-card-subtitle>

        <v-card-text class="text--primary mt-3">
          <div v-html="dashboardDesc(d)" />         
        </v-card-text>

        <v-card-actions class="dashActions">
         <v-container style="margin:0 0 0 0">
           <v-row  style="margin-top:5px">
            <v-btn v-if="dealStatus_WIP(d)"  color="primary" text @click="navToApplication(d)">{{
                $t("labels.ContinueThisApplication")
              }}</v-btn>
               <v-btn v-if="d.RequestReview == true"  color="primary" text @click="navToReviewApplication(d)">{{
                $t("labels.ReviewThisApplication")
              }}</v-btn>
           </v-row>
           <v-row v-if="d.RequestReview == false">             
                <v-btn color="primary" text style="{height:15px;margin-top:10px;}" @click="openDialog(d)" v-if="!dealStatus_WIP(d)  && d.DocumentRequests.length > 0">{{$t("labels.ViewDealSummary")}}</v-btn>            
                <v-btn color="primary" text style="{height:15px;margin-top:5px;}" @click="openDialog(d)" v-if="!dealStatus_WIP(d)  && d.DocumentRequests.length === 0">{{$t("labels.ViewDealSummary")}}</v-btn>            
           </v-row>
           <v-row v-if="d.RequestReview == false">
               <v-btn color="primary" text  style="height:15px; margin-top:5px;" @click="openDocumentDialog(d)" v-if="!dealStatus_WIP(d) && d.DocumentRequests.length > 0">{{$t("labels.RequestDocuments")}}</v-btn>
             </v-row>
         </v-container>
        </v-card-actions>
      </v-card>
    </v-row>
     <v-dialog v-model="dialog"  width="900px">          
        <v-card>
          <v-card-title>
              <v-img class="white--text align-end" height="100px" src="/images/current-loan.png"></v-img>
              <span class="text-h5">{{$t("labels.DealSummary")}}</span><br/>                   
          </v-card-title>
          <v-card-text>
              <v-divider></v-divider>
                <c_dealSummary :deal="selectedDeal"></c_dealSummary>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>         
                 <v-btn color="primary" text @click="closeDialog()">{{$t("labels.Close")}}</v-btn>
            </v-card-actions>
          </v-card>
     </v-dialog> 
    <v-dialog v-model="documentDialog"  width="900px">                
      <v-card>
        <v-card-title>
          <v-img class="white--text align-end" height="100px" src="/images/current-loan.png"></v-img>
          <span class="text-h5">{{$t("labels.RequestDocuments")}}</span><br/>                   
        </v-card-title>
          <v-card-text>
            <c_dealRequestDocuments :deal="selectedDeal"></c_dealRequestDocuments>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>         
            <v-btn color="primary" text @click=" closeDocumentDialog()">{{$t("labels.Close")}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>        
    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
  </div>
</template>
<script>
import localStorageSvc from "@/services/localStorage";
import dataSvc from "@/services/dataService";
import c_dealSummary from "./deal-summay.vue"
import c_dealRequestDocuments from "./deal-request-documents.vue"
export default {
  components:{c_dealSummary, c_dealRequestDocuments},
  data() {
      return {
      dialog:false,
      selectedDeal:{},
      documentDialog:false,
      pd: {},
      loadFlag: false,
      userID: null,
      siteID: this.$route.params.siteid
    };
  },  
  methods: {
     openDocumentDialog(deal){
      this.selectedDeal = deal
      this.documentDialog = true
    },
     closeDocumentDialog(){
       this.documentDialog = false
    },
    openDialog(deal){
      this.selectedDeal = deal,
      this.dialog = true
    },
    closeDialog(){
      this.dialog = false;      
    },
    navToApplication(d){
      if(this.dealStatus_WIP(d))
        this.$router.push('/' + this.siteID + '/user/' + d.MortgageApplicationID + '/start');
    },
    navToReviewApplication(d)
    {
      if(d.RequestReview == true && d.DisplayMortgage == true)
      {
        this.$router.push('/' + this.siteID + '/user/' + d.MortgageApplicationID + '/start');
      }else if(d.RequestReview == true && d.DisplayMortgage == false){
        this.$router.push('/' + this.siteID + '/user/' + d.MortgageApplicationID + '/summary');
      }
    },
    dealStatus_WIP(d){
     if(d.MortgageApplicationStatusDD==11) return true;
      return false;
    },    
    dealStatus_Submit(d){
      if(d.MortgageApplicationStatusDD!=11) return true;
      return false;
    },   
    dashboardDesc(d){
      let temp = '';
      if(this.isPropertyFound(d) || this.isRefinance(d) || this.isRenewal(d)){
        if(this.dealStatus_WIP(d))
            temp = this.$t('labels.DashboardDealDesc_Purchase_WIP');
         else 
          temp = this.$t('labels.DashboardDealDesc_Purchase_Submitted');
      }
      if(this.isPropertyNotFound(d)){
         if(this.dealStatus_WIP(d))
            temp = this.$t('labels.DashboardDealDesc_PreApproval_WIP');
         else 
          temp = this.$t('labels.DashboardDealDesc_PreApproval_Submitted');
      }
      
      temp = temp.replace('{MainApplicantName}', d.MainBorrowerName);
      temp = temp.replace('{MTGAmount}',d.MortgageAmount);
      temp = temp.replace('{ClosingDate}',d.ClosingDate);

      return temp;
    },
    isOfferAccepted(d) {
      if (this.isPropertyFound(d) && d.SearchStageDD == 1) return true;
      return false;
    },
    isPropertyFound(d) {
      if (d.PurposeDD == 0) {
        if (d.SearchStageDD >= 1 && d.SearchStageDD <= 3) {
          return true;
        }
      }
      return false;
    },
    isPropertyNotFound(d) {
      if (d.PurposeDD == 0) {
        if (d.SearchStageDD >= 4 && d.SearchStageDD <= 5) {
          return true;
        }
      }
      return false;
    },
    isRefinance(d) {
      if (d.PurposeDD == 2) return true;
      return false;
    },
    isRenewal(d) {
      if (d.PurposeDD == 4) return true;
      return false;
    },
 
    createNew() {
      this.$router.push("/" + this.siteID + "/user/0/start");
      //@click="$router.push('/' + siteID + '/user/0/start')"
    },
    loadPage() {
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        LangID: localStorageSvc.getLanID()
      };

      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoadMyDeals", postData)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.pd = res.data;                       
          } else {
            this.$router.push("/" + this.siteID + '/home');
          }
        });
    }
  },
  created() {
    this.userID = localStorageSvc.getUser();
    if (!this.userID) {
      this.$router.push("/" + this.siteID + "/home");
      return;
    }
    this.loadPage();
  }
};
</script>

<style scoped>
.bg {
  background: url(/images/bg3.png) no-repeat center center fixed;
  height: 100%;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>
